document.addEventListener('DOMContentLoaded', function () {
  var lightbox = document.querySelector('[data-gallery-lightbox]');
  if (!lightbox) return;

  // Move the lightbox to the very end of <body>. Dawn (and most themes)
  // apply a CSS transform to a wrapper element for cart/menu drawer
  // animations — once any ancestor has a transform, `position: fixed`
  // stops being relative to the real viewport and gets trapped inside
  // that ancestor instead. Re-parenting to <body> guarantees this
  // viewer always covers the full page correctly.
  document.body.appendChild(lightbox);

  var stage = lightbox.querySelector('[data-gallery-stage]');
  var lightboxImage = lightbox.querySelector('[data-gallery-lightbox-image]');
  var cursorEl = lightbox.querySelector('[data-gallery-cursor]');
  var overlayEl = lightbox.querySelector('[data-gallery-overlay]');
  var closeBtn = lightbox.querySelector('[data-gallery-close]');
  var prevBtn = lightbox.querySelector('[data-gallery-prev]');
  var nextBtn = lightbox.querySelector('[data-gallery-next]');
  var currentEl = lightbox.querySelector('[data-gallery-current]');
  var galleryItems = document.querySelectorAll('[data-gallery-item]');
  var mediaJsonEl = document.querySelector('[data-gallery-media-json]');
  var mediaList = [];
  var currentIndex = 0;

  var ZOOM_SCALE = 2.5;
  var isZoomed = false;
  var isDragging = false;
  var hasDragged = false;
  var scale = 1;
  var translateX = 0;
  var translateY = 0;
  var dragStartX = 0;
  var dragStartY = 0;
  var startTranslateX = 0;
  var startTranslateY = 0;

  if (mediaJsonEl) {
    try {
      mediaList = JSON.parse(mediaJsonEl.textContent);
    } catch (err) {
      mediaList = [];
    }
  }

  function applyTransform() {
    lightboxImage.style.transform =
      'scale(' + scale + ') translate(' + translateX + 'px, ' + translateY + 'px)';
  }

  function setZoom(active) {
    isZoomed = active;
    scale = active ? ZOOM_SCALE : 1;
    translateX = 0;
    translateY = 0;
    applyTransform();
    if (overlayEl) overlayEl.classList.toggle('is-active', active);
    if (stage) stage.classList.toggle('is-zoomed', active);
    if (cursorEl) cursorEl.classList.remove('is-active');
  }

  function renderImage(index) {
    if (!mediaList.length) return;
    currentIndex = (index + mediaList.length) % mediaList.length;
    var item = mediaList[currentIndex];
    lightboxImage.src = item.src;
    lightboxImage.alt = item.alt || '';
    if (currentEl) currentEl.textContent = currentIndex + 1;
    setZoom(false);
  }

  function matchSectionBackground(triggerEl) {
    var section = triggerEl.closest('.custom-product-section') || triggerEl.closest('[data-section-id]');
    if (!section) return;
    var bg = window.getComputedStyle(section).backgroundColor;
    if (bg) lightbox.style.backgroundColor = bg;
  }

  function openLightbox(triggerEl) {
    var index = parseInt(triggerEl.getAttribute('data-media-index'), 10) || 0;
    matchSectionBackground(triggerEl);
    renderImage(index);
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeLightbox() {
    lightbox.hidden = true;
    lightboxImage.src = '';
    setZoom(false);
    document.body.style.overflow = '';
  }

  galleryItems.forEach(function (item) {
    item.addEventListener('click', function () {
      openLightbox(item);
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(item);
      }
    });
  });

  closeBtn.addEventListener('click', closeLightbox);

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      renderImage(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      renderImage(currentIndex + 1);
    });
  }

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft' && !isZoomed) renderImage(currentIndex - 1);
    if (e.key === 'ArrowRight' && !isZoomed) renderImage(currentIndex + 1);
  });

  // "+" cursor hint shown only before zooming in.
  if (stage && cursorEl) {
    stage.addEventListener('mousemove', function (e) {
      if (isZoomed) return;
      var stageRect = stage.getBoundingClientRect();
      var imgRect = lightboxImage.getBoundingClientRect();
      var withinImage =
        e.clientX >= imgRect.left &&
        e.clientX <= imgRect.right &&
        e.clientY >= imgRect.top &&
        e.clientY <= imgRect.bottom;
      cursorEl.style.left = (e.clientX - stageRect.left) + 'px';
      cursorEl.style.top = (e.clientY - stageRect.top) + 'px';
      cursorEl.classList.toggle('is-active', withinImage);
    });

    stage.addEventListener('mouseleave', function () {
      cursorEl.classList.remove('is-active');
    });
  }

  // Click-and-drag panning while zoomed in.
  lightboxImage.addEventListener('mousedown', function (e) {
    if (!isZoomed) return;
    e.preventDefault();
    isDragging = true;
    hasDragged = false;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    startTranslateX = translateX;
    startTranslateY = translateY;
    if (stage) stage.classList.add('is-dragging');
  });

  window.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var dx = e.clientX - dragStartX;
    var dy = e.clientY - dragStartY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) hasDragged = true;
    translateX = startTranslateX + dx / scale;
    translateY = startTranslateY + dy / scale;
    applyTransform();
  });

  window.addEventListener('mouseup', function () {
    if (!isDragging) return;
    isDragging = false;
    if (stage) stage.classList.remove('is-dragging');
  });

  lightboxImage.addEventListener('dragstart', function (e) {
    e.preventDefault();
  });

  // Plain click (no drag) toggles zoom in / out.
  lightboxImage.addEventListener('click', function (e) {
    e.stopPropagation();
    if (hasDragged) {
      hasDragged = false;
      return;
    }
    setZoom(!isZoomed);
  });
});

// ---- Thumbnail rail: clicking a thumbnail swaps the main image ----
document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('[data-custom-gallery]');
  if (!gallery) return;

  var mainWrap = gallery.querySelector('.custom-product-gallery__main');
  var mainImage = mainWrap ? mainWrap.querySelector('.custom-product-gallery__image') : null;
  var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  var mediaJsonEl = document.querySelector('[data-gallery-media-json]');
  var mediaList = [];

  if (!mainWrap || !mainImage || !thumbs.length) return;

  if (mediaJsonEl) {
    try {
      mediaList = JSON.parse(mediaJsonEl.textContent);
    } catch (err) {
      mediaList = [];
    }
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = parseInt(thumb.getAttribute('data-thumb-index'), 10) || 0;
      var item = mediaList[index];
      if (!item) return;

      // Shopify's image_tag filter renders the main image with a
      // srcset/sizes pair for responsive loading. Browsers give srcset
      // priority over a plain src attribute whenever both are present,
      // so just reassigning .src here silently has no visual effect
      // until the leftover srcset/sizes are cleared first.
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = item.src;
      mainImage.alt = item.alt || '';
      mainWrap.setAttribute('data-media-index', index);

      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });
});